import React from "react";
import { MenuItem, CircularProgress } from "@mui/material";
import { useFormikContext } from "formik";
import FormField from "components/FormField";
import { useGetFirmantesQuery } from "services/escuela/firmante";

const SelectFirmante = () => {
  const { values, errors, touched, handleChange } = useFormikContext();

  const { data: firmantesData, isLoading: isLoadingFirmantes } =
    useGetFirmantesQuery(
      {
        filter_params: {
          query: "{id,url,user{first_name,apellido_paterno,apellido_materno}}",
        },
        shape: {
          id: "id",
          url: "url",
          nombre: "user.first_name",
          apellido_paterno: "user.apellido_paterno",
          apellido_materno: "user.apellido_materno",
        },
      },
      { refetchOnReconnect: true, refetchOnMountOrArgChange: true },
    );

  const firmantes = firmantesData?.results || firmantesData || [];

  return (
    <FormField
      select
      label="Firmante"
      name="firmante"
      value={values.firmante}
      onChange={handleChange}
      error={errors.firmante && touched.firmante}
      disabled={isLoadingFirmantes}
    >
      <MenuItem value="">
        <em>Seleccione un firmante</em>
      </MenuItem>
      {isLoadingFirmantes ? (
        <MenuItem disabled>
          <CircularProgress size={20} />
        </MenuItem>
      ) : (
        firmantes.map((firmante) => (
          <MenuItem key={firmante.id} value={firmante.url}>
            {`${firmante.nombre || ""} ${firmante.apellido_paterno || ""} ${firmante.apellido_materno || ""}`}
          </MenuItem>
        ))
      )}
    </FormField>
  );
};

export default SelectFirmante;
